import { useState } from 'react'
import Section from '@/components/Section'
import EmailCapture from '@/components/EmailCapture'
import { LEAD_MAGNETS } from '@/data/landing'
import Swal from 'sweetalert2'

export default function LeadMagnets() {
  const [expanded, setExpanded] = useState(false)
  const initialVisible = 4
  const visibleMagnets = expanded ? LEAD_MAGNETS : LEAD_MAGNETS.slice(0, initialVisible)

  const handleLeadSuccess = (
    title: string,
    data: { success: boolean; message: string; downloadUrl?: string }
  ) => {
    if (data.downloadUrl) {
      Swal.fire({
        icon: 'success',
        title: 'Your download is ready!',
        html: `
          <p style="color: #6B5F7B; margin-bottom: 8px;">
            <strong>${title}</strong> is ready for download.
          </p>
          <p style="color: #9B8FB0; font-size: 14px;">
            We also sent a copy to your email so you can access it later.
          </p>
        `,
        confirmButtonText: 'Download Now',
        confirmButtonColor: '#D4A843',
        showCancelButton: true,
        cancelButtonText: 'Close',
        cancelButtonColor: '#6B5F7B',
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(data.downloadUrl, '_blank')
        }
      })
    } else {
      Swal.fire({
        icon: 'success',
        title: 'Check your inbox!',
        text: `Your ${title} is on its way to your email.`,
        confirmButtonText: 'Got it',
        confirmButtonColor: '#D4A843',
      })
    }
  }

  return (
    <div id="free" className="bg-bg-warm py-24 px-6 relative mt-12">
      <div className="max-w-[960px] mx-auto">
        <Section>
          <div className="text-center mb-14">
            <span className="inline-block py-1.5 px-4 rounded-full bg-tag-gold-bg text-tag-gold-text text-[11px] font-semibold tracking-[2px] uppercase mb-4">
              Free Downloads
            </span>
            <h2 className="font-display text-[clamp(30px,5vw,44px)] font-bold text-text-dark leading-[1.15] mb-4">
              Grab a Free Checklist
            </h2>
            <p className="text-text-gray text-[17px] max-w-[480px] mx-auto leading-relaxed">
              Practical, no-fluff guides for spiritual centers.
              Enter your email and it's yours instantly.
            </p>
          </div>
        </Section>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {visibleMagnets.map((lm, i) => (
            <Section key={lm.slug} delay={`${i * 0.08}s`}>
              <div className="bg-card-bg rounded-2xl p-7 border border-card-border shadow-[0_2px_12px_rgba(28,18,40,0.04)] transition-all duration-300 hover:shadow-[0_8px_30px_rgba(28,18,40,0.08)]">
                <span className="text-[30px] block mb-3">{lm.emoji}</span>
                <div className="font-bold text-[16px] text-text-dark mb-1">{lm.title}</div>
                <div className="text-text-gray text-sm mb-5 leading-normal">{lm.desc}</div>
                <EmailCapture
                  placeholder="Your email"
                  buttonText="Get It"
                  source={lm.title}
                  type="lead"
                  onSuccess={(data) => handleLeadSuccess(lm.title, data)}
                />
              </div>
            </Section>
          ))}
        </div>

        {LEAD_MAGNETS.length > initialVisible ? (
          <div className="text-center mt-8">
            <button
              type="button"
              onClick={() => setExpanded((v) => !v)}
              className="inline-block py-2.5 px-6 rounded-full border border-brand-mid/25 bg-white text-brand-mid text-sm font-semibold transition-all duration-200 hover:scale-[1.02] hover:bg-brand-mid/5"
            >
              {expanded ? 'View Less' : 'View More'}
            </button>
          </div>
        ) : null}
      </div>
    </div>
  )
}
